var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"block",class:_vm.iconClass,on:{"click":function($event){return _vm.$emit('click')},"mouseenter":function($event){return _vm.toggleHover(true)},"mouseleave":function($event){return _vm.toggleHover(false)}}},[_c('icon',_vm._b({staticClass:"transition-all",style:({
      'font-size': _vm.iconSize,
      transform: ("rotate(" + (_vm.rotation || 0) + "deg)")
    }),attrs:{"icon":_vm.icon}},'icon',_vm.$props,false)),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }